<script>
    import I18n from '@js/modules/translations';

    import AnalyticsService from '@js/modules/analyticsService';

    import Icon from '@js/components/themes/Icon.svelte';

    import copyIcon from '@js/components/icons/copyIcon';
    import emailIcon from '@js/components/icons/emailIcon';
    import facebookIcon from '@js/components/icons/facebookIcon';
    import twitterIcon from '@js/components/icons/twitterIcon';
    import linkedinIcon from '@js/components/icons/linkedinIcon';
    import whatsappIcon from '@js/components/icons/whatsappIcon';

    const {
        sharedUrl,
        sharedName
    } = $props();

    let urlCopied = $state(false);

    const shareTitle = I18n.t('js.ride.share.tools.title', {name: sharedName});
    const shareContent = I18n.t('js.ride.share.tools.content', {url: sharedUrl});

    const mailSubject = encodeURIComponent(shareTitle);
    const mailBody = encodeURIComponent(shareContent);
    const mailtoLink = `mailto:?subject=${mailSubject}&body=${mailBody}`;

    const _share = (tool, event) => {
        event.preventDefault();

        let url = '';

        switch (tool) {
            case 'facebook':
                url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(sharedUrl)}`;
                break;
            case 'twitter':
                url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(sharedUrl)}&text=${encodeURIComponent(sharedName)}`;
                break;
            case 'linkedin':
                url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(sharedUrl)}&title=${encodeURIComponent(sharedName)}`;
                break;
            case 'whatsapp':
                url = `https://api.whatsapp.com/send?text=${encodeURIComponent(sharedName + ' ' + sharedUrl)}`;
                break;
        }

        if (navigator.share) {
            navigator.share({
                title: shareTitle,
                text: shareContent,
                url: sharedUrl
            });
        } else {
            window.open(url, '_blank', 'width=600,height=500');
        }

        AnalyticsService.trackRideShared(tool);
    };

    const _handleCopyUrlToClipboard = (event) => {
        event.preventDefault();

        navigator.clipboard.writeText(sharedUrl)
            .then(() => urlCopied = true);
    };
</script>

<div class="w-full mx-auto xl:w-2/3">
    <div class="p-6 text-center">
        <h1 class="title-h1 max-w-[86%] mx-auto text-xl md:text-2xl">
            {I18n.t('js.ride.share.submit')}
        </h1>

        <div class="flex flex-col items-center justify-center p-2 md:p-6 space-y-4">
            <div class="w-full max-w-md p-2.5 text-center bg-white border border-gray-200 rounded-lg shadow-lg">
                <a class="block p-4 text-sm text-gray-700 underline break-all"
                   target="_blank"
                   href={sharedUrl}>
                    {sharedUrl}
                </a>

                <button class="flex items-center justify-center w-full p-2 font-bold text-white text-sm bg-secondary-600 rounded-md hover:bg-secondary-800 active:bg-secondary-800 transition"
                        onclick={_handleCopyUrlToClipboard}>
                    <Icon class="shrink-0 w-4 h-4 mr-2 text-white"
                          icon={copyIcon}/>
                    {#if urlCopied}
                        {I18n.t('js.ride.share.copied')}
                    {:else}
                        {I18n.t('js.ride.share.copy')}
                    {/if}
                </button>

                <div class="flex items-center justify-center gap-3 my-6">
                    <a class="flex flex-col mx-auto text-xs"
                       href={mailtoLink}>
                        <Icon class="shrink-0 w-9 h-9 mx-auto mb-1 p-1 bg-gray-200 hover:bg-gray-200 rounded-full"
                              icon={emailIcon}/>
                        Email
                    </a>
                    <button class="flex flex-col mx-auto text-xs"
                            onclick={_share.bind(this, 'facebook')}>
                        <Icon class="shrink-0 w-9 h-9 mx-auto mb-1 p-1 bg-gray-200 hover:bg-gray-200 rounded-full"
                              icon={facebookIcon}/>
                        Facebook
                    </button>
                    <button class="flex flex-col mx-auto text-xs"
                            onclick={_share.bind(this, 'twitter')}>
                        <Icon class="shrink-0 w-9 h-9 mx-auto mb-1 p-1 bg-gray-200 hover:bg-gray-200 rounded-full"
                              icon={twitterIcon}/>
                        Twitter
                    </button>
                    <button class="flex flex-col mx-auto text-xs"
                            onclick={_share.bind(this, 'linkedin')}>
                        <Icon class="shrink-0 w-9 h-9 mx-auto mb-1 p-1 bg-gray-200 hover:bg-gray-200 rounded-full"
                              icon={linkedinIcon}/>
                        LinkedIn
                    </button>
                    <button class="flex flex-col mx-auto text-xs"
                            onclick={_share.bind(this, 'whatsapp')}>
                        <Icon class="shrink-0 w-9 h-9 mx-auto mb-1 p-1 bg-gray-200 hover:bg-gray-200 rounded-full"
                              icon={whatsappIcon}/>
                        WhatsApp
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
